import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'
import {
    selectAllEditGeneralActivities,
    selectAllEditTodos,
} from '../../../state/itineraryState/currentItin.slice'
import { SectionButton } from './sectionButton'
import { sectionTranslation } from '../../../i18n/translateHelpers'

export const ActivitiesButton = () => {
    const { selectedItinID } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItinID: s.selectedItinID,
            }
        })
    )
    const activities = useBoundStore(selectAllEditGeneralActivities)
    const todos = useBoundStore(selectAllEditTodos)
    return (
        <SectionButton
            claimPaths={[`/${selectedItinID}/8`]}
            claims={['editItinerary']}
            elementID={'activities'}
            count={activities.length + todos.length}
            onClick={() => {
                window.pushPath('/edit/activities/general')
            }}
            icon={'Activity'}
            text={sectionTranslation('Activities')}
        />
    )
}
